import type { PixelSprite } from './pixelBroker';
import { spritePaths, unpackRuns } from './pixelPalette';

const cache = new WeakMap<PixelSprite, readonly (readonly [number, string])[]>();

/** A pixel sprite's rectangles, in its own palette, to sit inside an SVG of its size. */
export function SpritePaths({ sprite }: { sprite: PixelSprite }) {
  let paths = cache.get(sprite);
  if (!paths) {
    paths = spritePaths(unpackRuns(sprite.runs), sprite.w);
    cache.set(sprite, paths);
  }
  return (
    <>
      {paths.map(([c, d]) => (
        <path key={c} d={d} fill={sprite.palette[c]} />
      ))}
    </>
  );
}
